<template>
    <div id="app" :class="{isAe: $i18n.locale === 'ae' ? true : false}">
        <transition name="slide-fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'app'
}
</script>

<style>
#app {
    height: 100%;
    font-family: Microsoft YaHei;
    overflow: hidden;
}
.el-button{
    font-family: Microsoft YaHei;
}
.el-submenu__title i{
    color: #fff;
}
.downStyle .popper__arrow{
    left: 65px!important;
}
.loginDownStyle .popper__arrow{
    left: 100px!important;
}
</style>



// WEBPACK FOOTER //
// App.vue?1991debc